module.exports = __webpack_public_path__ + "static/media/LearnCreatorHowItWorks3.69ac68c8.png";